import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

const EditableField = ({
  label,
  value,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  children,
  width = "60%",
}) => {
  return (
    <SuiBox mb={2}>
      <SuiBox display="flex" alignItems="center" justifyContent="space-between">
        <SuiTypography variant="subtitle2" fontWeight="medium" textColor="text">
          {label}
        </SuiTypography>
      </SuiBox>
      <SuiBox display="flex" alignItems="center">
        <SuiBox width={width} mr={2}>
          {isEditing ? (
            children
          ) : (
            <SuiTypography variant="button" fontWeight="regular" textColor="text">
              {value || "No especificado"}
            </SuiTypography>
          )}
        </SuiBox>
        {isEditing ? (
          <>
            <IconButton onClick={onSave} size="small">
              <SaveIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={onCancel} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        ) : (
          <IconButton onClick={onEdit} size="small">
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </SuiBox>
    </SuiBox>
  );
};

EditableField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node,
  width: PropTypes.string,
};

export default EditableField;
